/* eslint-disable no-restricted-imports */
'use client';
import LegacyStyledComponentsPage from '~/client/containers/LegacyStyledComponentsPage';
import Tournaments from '~/client/features/Tournaments/modules/TournamentLists';

const TournamentsComponent = () => (
  <LegacyStyledComponentsPage>
    <Tournaments />
  </LegacyStyledComponentsPage>
);

export default TournamentsComponent;
